import React from 'react';
import { ArrowRightIcon, CalendarIcon, ClockIcon, MapPinIcon } from 'lucide-react';
import { SectionHeading } from '../ui/SectionHeading';
import { Reveal } from '../ui/Reveal';
import { Button } from '../ui/Button';
import { upcomingEvents } from '../../data/news';
export function UpcomingEvents() {
  return <section aria-labelledby="events-heading" className="bg-sand-100 py-16 sm:py-20 lg:py-28" data-id="element-401" data-mp="plod1ywnpe8v">
      <div className="mx-auto max-w-content px-4 sm:px-6 lg:px-10" data-id="element-402" data-mp="axbeqva3jjb7">
        <SectionHeading eyebrow="On the trail" title="Where we will be next" action={<Button variant="secondary" data-id="element-404" data-mp="1xewpci7pip4">
              View the campaign calendar
              <ArrowRightIcon aria-hidden className="h-[18px] w-[18px]" data-id="element-405" data-mp="5y792emds3pm" />
            </Button>} data-id="element-403" data-mp="foa0499xz7lb" />

        <ul className="mt-12 grid gap-6 md:grid-cols-2 lg:grid-cols-3" data-id="element-406" data-mp="3o3jz38ijbwov">
          {upcomingEvents.map((event, index) => <li key={event.title} className="h-full" data-id="element-407" data-mp="3t1v7det6lz4z" data-mpi={index}>
              <Reveal delay={index * 0.05} className="h-full" data-id="element-408" data-mp="39dz3qam0twfa">
                <article className="group flex h-full flex-col overflow-hidden rounded-card border border-sand-200 bg-white shadow-card transition-[border-color,box-shadow] duration-200 ease-emphasis hover:border-green-200 hover:shadow-lift" data-id="element-409" data-mp="39c5x2vberc7a">
                  <div className="relative overflow-hidden" data-id="element-410" data-mp="3dfu6ljjlohv6">
                    <img src={event.image} alt="" loading="lazy" className="aspect-[16/10] w-full object-cover transition-transform duration-300 ease-emphasis group-hover:scale-[1.02]" data-id="element-411" data-mp="3ddhpf8lo2bj6" />
                    <span className="absolute left-4 top-4 rounded bg-ink/85 px-2.5 py-1 text-[11px] font-bold uppercase tracking-[0.1em] text-white" data-id="element-412" data-mp="2zh48c0l1oc58">
                      {event.type}
                    </span>
                  </div>
                  <div className="flex flex-1 flex-col p-6" data-id="element-413" data-mp="220oz828ixv58">
                    <h3 className="font-display text-[20px] leading-snug text-ink" data-id="element-414" data-mp="2205jms6cjiud">
                      {event.title}
                    </h3>
                    <dl className="mt-4 space-y-2 text-[14px] text-slate-600" data-id="element-415" data-mp="avu5b3um2rjz">
                      <div className="flex items-center gap-2.5" data-id="element-416" data-mp="fn3te00ihmtr">
                        <dt className="sr-only" data-id="element-417" data-mp="fnvq5e5uhqlm">Date</dt>
                        <CalendarIcon aria-hidden className="h-4 w-4 text-green-600" data-id="element-418" data-mp="kmovukew4db8" />
                        <dd data-id="element-419" data-mp="3j42i4newdzek">{event.date}</dd>
                      </div>
                      <div className="flex items-center gap-2.5" data-id="element-420" data-mp="3j65hvz5ur6wh">
                        <dt className="sr-only" data-id="element-421" data-mp="3o3oy34m41tr2">Time</dt>
                        <ClockIcon aria-hidden className="h-4 w-4 text-green-600" data-id="element-422" data-mp="3t28hoyd8etg9" />
                        <dd data-id="element-423" data-mp="y7o2apuanwu">{event.time}</dd>
                      </div>
                      <div className="flex items-start gap-2.5" data-id="element-424" data-mp="ziteeyxo3q2">
                        <dt className="sr-only" data-id="element-425" data-mp="18apwl75tupg3">Venue</dt>
                        <MapPinIcon aria-hidden className="mt-0.5 h-4 w-4 shrink-0 text-green-600" data-id="element-426" data-mp="1cdcspk9j6wj3" />
                        <dd data-id="element-427" data-mp="2wvdv8fvvfrrr">
                          {event.venue}, {event.city} ({event.state})
                        </dd>
                      </div>
                    </dl>
                    <div className="mt-auto flex items-center gap-3 pt-6" data-id="element-428" data-mp="2svwolj4pkol0">
                      <Button size="sm" data-id="element-429" data-mp="2o1seir05c0fp">RSVP</Button>
                      <a href="/events" className="inline-flex items-center gap-1.5 text-[14px] font-semibold text-green-700 transition-colors duration-150 ease-emphasis hover:text-green-800" data-id="element-430" data-mp="2j48qizdnc9ak">
                        Event details
                        <ArrowRightIcon aria-hidden className="h-4 w-4" data-id="element-431" data-mp="253xxpqss0kmr" />
                      </a>
                    </div>
                  </div>
                </article>
              </Reveal>
            </li>)}
        </ul>
      </div>
    </section>;
}